import { render } from "./SimulatorView.vue?vue&type=template&id=b94671d0&scoped=true"
import script from "./SimulatorView.vue?vue&type=script&lang=js"
export * from "./SimulatorView.vue?vue&type=script&lang=js"

import "./SimulatorView.vue?vue&type=style&index=0&id=b94671d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b94671d0"]])

export default __exports__